<div class="p-5 text-danger text-center">
    <div *ngFor="let alert of alerts" class="pt-2">
        <alert (onClosed)="onClosed(alert)" [dismissible]="dismissible" [type]="alert.type">
            <span class="alertMessage">{{alert.message}}</span>
        </alert>
    </div>
</div>
